const log = require('loglevel');

function _concatenateMessage(args) {
  var msg = '';
  args.forEach(function(arg) {
    if (typeof arg === 'object') {
      try {
        arg = `\n ${JSON.stringify(arg, null, 2)}`;
      } catch (err) {
        if (!process.env.REACT_APP_LOG_LEVEL === 'error') {
          console.warn('[logger] was not able to flatten object due to', err);
          console.warn('[logger] arg:')
          console.warn(arg);
        }
      }
    }
    msg += ` ${arg}`;
  });
  return msg;
}


module.exports.logger = function(module) {
  const moduleName = module;
  log.setLevel(process.env.REACT_APP_LOG_LEVEL || 'trace');

  return {
    trace: function() {
      log.debug(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    },
    debug: function() {
      log.debug(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    },
    info: function() {
      log.info(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    },
    warn: function() {
      log.warn(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    },
    error: function() {
      log.error(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    },
    log: function() {
      if (!process.env.REACT_APP_LOG_LEVEL === 'error') {
        console.warn('[DEPRECATION] PLEASE USE log.debug` instead. See `lib/ks-logger`');
      }
      // log.info(`[${moduleName}]${_concatenateMessage([...arguments])}`)
    }
  }
};